import { makeHookable } from './makeHookable';

export function hookable(clazz: React.ComponentClass) {
  return makeHookable(clazz);
}
